<template>
<div id="content-cards">
    <div class="txt-index">
        <div class="cards">
            <h2>¡Bienvenidos!</h2>
            <p>Por medio de esta página usted podrá interponer o gestionar peticiones, quejas, reclamos, felicitaciones o sugerencias, gracias por utilizar nuestros servicios.</p>
        </div>
    </div>
    <div class="img-index">
        <img src="/static/img/home.png">
    </div>
</div>
</template>

<script>
    export default{
        name: 'emt-home'
    }
</script>



// WEBPACK FOOTER //
// emt-home.vue?d34dc534